module.exports = __webpack_public_path__ + "static/img/ct.2f0a577.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/en/ct.png
// module id = NNK/
// module chunks = 1